export default __webpack_public_path__ + "static/media/lds-logo_to.287286583a9b36f8.svg";